/* ==========================================================================
   Custom Global Scripts - c_custom.js
   Pipeline Theme Customization
   ========================================================================== */

(function () {
  'use strict';

  const HEADER_BREAKPOINT = 836;

  document.addEventListener('DOMContentLoaded', function () {
    initSearchPopdown();
    initHeaderBreakpoint();
    initDropdownHoverDelay();
    initRecentlyViewedEmpty();
    initContactFormValidation();
    initExternalLinks();
    initBackInStock();
  });

  /**
   * ヘッダー表示切替を836pxで固定（中間レイアウトを解消）
   * テーマの動的minWidthを上書きし、836px未満でスマホ表示
   */
  function initHeaderBreakpoint() {
    function applyBreakpoint() {
      var wrapper = document.querySelector('.header__wrapper[data-header-wrapper]');
      if (!wrapper) return;
      var width = document.body.clientWidth;
      if (width < HEADER_BREAKPOINT) {
        wrapper.classList.add('js__show__mobile');
      } else {
        wrapper.classList.remove('js__show__mobile');
      }
    }
    document.addEventListener('theme:resize', function () {
      setTimeout(applyBreakpoint, 0);
    });
    setTimeout(applyBreakpoint, 0);
  }

  /**
   * 検索ポップダウン初期化
   * c_header は section type が header と異なるため、検索ボタンクリックで
   * ポップダウンが開かない問題を解消（PCでも検索ボックス表示）
   */
  function initSearchPopdown() {
    const triggers = document.querySelectorAll('[data-popdown-toggle="search-popdown"]');
    const popdown = document.getElementById('search-popdown');
    const wrapper = document.querySelector('[data-search-popdown-wrap]');
    const underlay = wrapper ? wrapper.querySelector('[data-search-underlay]') : null;
    const input = popdown ? popdown.querySelector('[data-predictive-search-input]') : null;
    const closeBtn = popdown ? popdown.querySelector('[data-close-popdown]') : null;

    if (!popdown || !triggers.length) return;

    function showPopdown() {
      popdown.classList.add('is-visible');
      if (underlay) underlay.classList.add('underlay--visible');
      if (input) {
        setTimeout(function () { input.focus(); }, 50);
      }
      document.documentElement.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));
    }

    function hidePopdown() {
      popdown.classList.remove('is-visible');
      if (underlay) underlay.classList.remove('underlay--visible');
      document.documentElement.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        showPopdown();
      });
    });

    if (underlay) {
      underlay.addEventListener('click', hidePopdown);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', hidePopdown);
    }

    document.addEventListener('keydown', function (e) {
      if (e.code === 'Escape' && popdown.classList.contains('is-visible')) {
        hidePopdown();
      }
    });
  }

  /**
   * 下層メニューへの移動で消えないよう透明ブリッジを追加
   * メニューとドロップダウンの間に常にヒットする領域を確保
   */
  function initDropdownHoverDelay() {
    var wrapper = document.querySelector('.header__wrapper[data-header-wrapper]');
    if (!wrapper) return;

    setTimeout(function () {
      var disclosures = wrapper.querySelectorAll('[data-hover-disclosure]');
      disclosures.forEach(function (disclosure) {
        var key = disclosure.id;
        var trigger = document.querySelector('[data-hover-disclosure-toggle="' + key + '"]');
        if (!trigger || !disclosure) return;
        if (disclosure.querySelector('[data-hover-disclosure-bridge]')) return;

        function show() {
          trigger.classList.add('is-visible');
          trigger.setAttribute('aria-expanded', 'true');
          disclosure.classList.add('is-visible');
          if (trigger.classList.contains('grandparent')) {
            wrapper.classList.add('meganav--visible');
          } else {
            wrapper.classList.remove('meganav--visible');
          }
        }

        var bridge = document.createElement('div');
        bridge.setAttribute('data-hover-disclosure-bridge', key);
        bridge.style.cssText = 'position:absolute;top:-8px;left:0;right:0;height:40px;z-index:10;pointer-events:auto;';
        bridge.addEventListener('pointerenter', show);
        trigger.style.position = 'relative';
        trigger.appendChild(bridge);
      });
    }, 200);
  }
  /**
   * 最近見た商品セクション：商品が読み込まれたらデフォルトメッセージを非表示、
   * テーマJSがセクションをhideした場合はメッセージを表示し直す
   */
  function initRecentlyViewedEmpty() {
    var sections = document.querySelectorAll('.c-empty-message--rv');
    if (!sections.length) return;

    sections.forEach(function (msg) {
      var section = msg.closest('.section-related');
      if (!section) return;

      function showEmptyState() {
        section.classList.remove('hide');
        var wrapper = section.querySelector('[data-recent-wrapper]');
        if (wrapper) wrapper.style.display = 'none';
        var tabContent = section.querySelector('.tab-content');
        if (tabContent) tabContent.style.display = 'none';
        msg.style.display = '';
      }

      section.addEventListener('theme:recent-products:added', function () {
        msg.style.display = 'none';
      });

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName !== 'class') return;
          if (section.classList.contains('hide')) {
            showEmptyState();
          }
        });
      });
      observer.observe(section, { attributes: true });

      if (section.classList.contains('hide')) {
        showEmptyState();
      }

      setTimeout(function () {
        if (section.classList.contains('hide')) {
          showEmptyState();
        }
      }, 2000);
    });
  }

  /**
   * 外部リンクに target="_blank" と rel="noopener noreferrer" を自動付与
   */
  function initExternalLinks() {
    var host = window.location.hostname;
    document.querySelectorAll('a[href]').forEach(function (a) {
      try {
        var url = new URL(a.href, window.location.origin);
        if (url.hostname && url.hostname !== host && url.protocol.indexOf('http') === 0) {
          if (!a.hasAttribute('target')) {
            a.setAttribute('target', '_blank');
          }
          var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
          if (rel.indexOf('noopener') === -1) rel.push('noopener');
          if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
          a.setAttribute('rel', rel.join(' '));
        }
      } catch (e) { /* mailto: tel: 等は無視 */ }
    });
  }

  /**
   * お問い合わせフォーム：クライアントサイドバリデーション
   * バリデーション通過まで送信をブロックする
   */
  function initContactFormValidation() {
    var form = document.getElementById('contact-us-page');
    if (!form) return;

    var isSubmitting = false;

    form.addEventListener('submit', function (e) {
      if (isSubmitting) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var valid = true;

      form.querySelectorAll('.c-contact__error.is-visible').forEach(function (el) {
        el.classList.remove('is-visible');
        el.textContent = '';
      });
      form.querySelectorAll('.c-contact__row.has-error').forEach(function (el) {
        el.classList.remove('has-error');
      });

      var fields = form.querySelectorAll('[data-contact-field][data-required="true"]');
      fields.forEach(function (field) {
        var type = field.getAttribute('data-field-type');
        var name = field.getAttribute('data-field-name') || '';
        var row = field.closest('[data-contact-row]');
        var errorEl = row ? row.querySelector('[data-contact-error]') : null;
        var empty = false;

        if (type === 'radio') {
          var radios = field.querySelectorAll('input[type="radio"]');
          var checked = false;
          radios.forEach(function (r) { if (r.checked) checked = true; });
          if (!checked) empty = true;
        } else if (type === 'checkbox') {
          if (!field.checked) empty = true;
        } else if (type === 'select') {
          if (!field.value) empty = true;
        } else {
          if (!field.value.trim()) empty = true;
        }

        if (type === 'email' && field.value.trim()) {
          var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(field.value.trim())) {
            empty = false;
            valid = false;
            if (row) row.classList.add('has-error');
            if (errorEl) {
              errorEl.textContent = '正しいメールアドレスを入力してください';
              errorEl.classList.add('is-visible');
            }
          }
        }

        if (empty) {
          valid = false;
          if (row) row.classList.add('has-error');
          if (errorEl) {
            errorEl.textContent = name + 'は必須項目です';
            errorEl.classList.add('is-visible');
          }
        }
      });

      var privacyCheck = form.querySelector('[data-privacy-check]');
      if (privacyCheck && !privacyCheck.checked) {
        valid = false;
        var privacyError = form.querySelector('[data-privacy-error]');
        if (privacyError) {
          privacyError.textContent = '個人情報保護方針への同意が必要です';
          privacyError.classList.add('is-visible');
        }
      }

      if (valid) {
        isSubmitting = true;
        form.submit();
      } else {
        var firstError = form.querySelector('.has-error, [data-privacy-error].is-visible');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }

  /* --------------------------------------------------------------------------
     Back in Stock – SOLD OUT時に再入荷通知ボタンを表示
     -------------------------------------------------------------------------- */
  function initBackInStock() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bis-btn]');
      if (!btn) return;
      var formId = btn.getAttribute('data-bis-form-id');
      if (formId) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      }
    });
  }
})();
